export const sitecoreCollaborativeProgramQuickaction = {
  type: 'ui',
  name: 'Join the Sitecore Collaborative Program',
  displayName: { name: 'Help us create better products' },
  icon: {
    type: 'mdi',
    src: 'mdiAccountGroupOutline',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://www.sitecore.com/help-us-build-products',
  },
};
